import { useServicesContext } from "../../providers/ServicesProvider";
import {
    ANALYTICS_EVENT_NAMES,
    ANALYTICS_FLOWS,
    ANALYTICS_TRACKED_COMPONENTS
} from "../../constants/analytics-constants";
import { useAnalyticsTracking } from "../useAnalyticsTracking/useAnalyticsTracking";

export const useInstancePermissions = () => {
    const { userService } = useServicesContext();
    const { sendTrackEvent } = useAnalyticsTracking();

    const getUserInstancePermissions = async ({ email }: { email: string }) => {
        const result = await userService.getUserInstancePermissions({ email });

        sendTrackEvent({
            name: ANALYTICS_EVENT_NAMES.SUPPORT_SEARCH_USER_PERMISSIONS,
            component: ANALYTICS_TRACKED_COMPONENTS.SUPPORT_ACCESS_SIDEBAR,
            flow: ANALYTICS_FLOWS.SUPPORT,
            data: {
                search: email
            }
        });
        return result;
    };

    return { getUserInstancePermissions };
};
